// Small floating photo preview that follows the cursor.
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.

export default function HoverPreview({ hoverPhoto }) {
  return (
    <>
      {/* Hover preview — small floating thumbnail near the cursor. */}
      {hoverPhoto && (
        <div style={{
          position: 'fixed',
          borderRadius: 4
        }}>
          <img src={hoverPhoto.url} alt={hoverPhoto.plate}
               style={{ width: 320, height: 'auto', display: 'block' }}
               onError={(e) => { e.currentTarget.style.display = 'none'; }} />
        </div>
      )}
    </>
  );
}
